export const ATJS_STATE = 'ATJS_STATE';
export const DOCUMENT_MODE = 'documentMode';

export const CLOUDINARY_ENDPOINT = 'https://res.cloudinary.com/originenergy/image/upload';
